export const initialOptions = (currency) => {
  return {
    'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: currency,
    intent: 'capture'
  };
};
